import { type ExportCell, type ExportColumns } from '../types';
import { downloadBlob, escapeCsvValue, formatCellValue } from '../utils';
import { UTF8_BYTE_ORDER_MARK } from '../constants';

const buildCsv = (columns: ExportColumns[], rows: ExportCell[][], formatDate?: (date: Date) => string) => {
  const header = columns.map((column) => escapeCsvValue(column.label)).join(',');
  const body = rows.map((row) => row.map((cell) => escapeCsvValue(formatCellValue(cell, formatDate))).join(','));
  return `${UTF8_BYTE_ORDER_MARK}${[header, ...body].join('\n')}`;
};

export const exportCsv = (options: {
  columns: ExportColumns[];
  rows: ExportCell[][];
  formatDate?: (date: Date) => string;
  fileName: string;
}) => {
  const csv = buildCsv(options.columns, options.rows, options.formatDate);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

  downloadBlob(blob, `${options.fileName}.csv`);
};
